import React from 'react';
import Reveal from './atoms/reveal';

const SKILLS = [
  {
    title: 'バックエンド',
    items: ['Kotlin, Java, SpringBoot', 'Python, Flask'],
  },
  {
    title: 'フロントエンド',
    items: ['JavaScript, TypeScript, React', 'Tailwind'],
  },
  {
    title: 'インフラストラクチャ',
    items: ['Kubernetes, AWS, Firebase'],
  },
];

function Skills() {
  return (
    <section id="skills" className="home-section parallax text-center py-10" data-stellar-background-ratio="0.5">
      <div className="flex items-center justify-center py-5">
        <div className="container relative z-30">
          <Reveal className="section-heading text-center">
            <h2 className="text-4xl text-center font-semibold pb-6">Skills</h2>
          </Reveal>

          <div className="grid gap-3 grid-flow-row-dense grid-cols-3 justify-center xl:px-40 px-10">
            {SKILLS.map((skill, i) => (
              <Reveal
                key={skill.title}
                variant="scale"
                delay={i * 120}
                className="col-span-3 lg:col-span-1"
              >
                <div className="bounce-hover h-full flex flex-col items-center bg-white border border-gray-200 rounded-lg shadow hover:shadow-xl">
                  <div className="flex flex-col justify-between p-4 leading-normal">
                    <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900">{skill.title}</h5>
                    {skill.items.map((item) => (
                      <p key={item} className="mb-3 font-normal text-gray-700">{item}</p>
                    ))}
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
export default Skills;
